<template>
    <div class="msp-andature-dettaglio" :class="classComponent" v-html="renderDescrizione(dettaglio, sport_id, {format: 'html', valoriZona})"></div>
</template>

<script>
import allenamentoCalcoli from "@src/js/vue/mixins/allenamentoCalcoli.js";
import {methods as methodsAndaturaZonaRange} from '@src/js/vue/mixins/andaturaZonaRange.js'
import _funzioni from '../../../js/msp/funzioni';
import { renderDescrizione } from "@shared/msp/descrizioneAutomatica.js";
const component = {
    props: [
    'um-zone',
    'dettaglio',
    'zone-attive',
    'sport_id',
    'tests',
    ],
  mixins: [
    allenamentoCalcoli,
  ],
  computed: {
        filtered_tests: function () {
            return _funzioni.filterTestsBySportId(this.tests, +this.sport_id);
        },

      classComponent: function () {
          if (+this.dettaglio.ripetute > 1) {
              return "has-ripetute";
          }
      },


  },
  methods: {
    ...methodsAndaturaZonaRange,
      renderDescrizione,

      // Valori della zona ricavati dal test dell'atleta (es. "92 - 104 W"), mostrati dopo
      // il nome del range. "" senza test per lo sport o se la zona non è nel test.
      valoriZona: function (andatura) {
          if (andatura.des_zona==="REC") return "";
          if (!(this.filtered_tests && this.filtered_tests.length)) return "";
          const test = (this.umZone)
              ? this.filtered_tests.find(el=>el.um_tipo_codice === this.umZone)
              : this.filtered_tests[0]; // prende il primo test come default
          if (!test) return "";
          const zona = this.makeZonaForRange(test, andatura.andatura_zona_id);
          if (!zona) return "";
          return this.formatDescrizioneZona(zona, andatura) || "";
      },
  }
}
export default component;
</script>

<style lang="scss">
.msp-andature-dettaglio {
    text-align: left;
    // Ogni opzione è un elemento a sé della riga dell'andatura (flex con wrap): segue
    // zona e valori finché c'è spazio e va a capo da sola; dentro un'opzione il testo
    // va a capo normalmente, tranne gli rpm (il "da-a" resta unito).
    .options {
        display: contents;
    }
    /* opzione con view.newLine in configAndatura.js: su una riga propria */
    .option.option--new-line {
        display: block;
        width: 100%;
    }
    .option--lap {
        font-weight: bold;
    }

    .option {
        margin: 0 2px;
        padding: 0 2px;
        display: inline-block;
        white-space: normal;
    }
    .option--rpm {
        display: inline-block;
        padding: 2px 6px;
        flex:0;
        border-radius: 5px;
        background-color: var(--col-grigio-chiarissimo);
        white-space: nowrap;
    }
    .option--note {
        font-style: italic;
    }
    .nome-percorso {
        display: inline-block;
        white-space: nowrap;
        padding: 0px 5px;
        align-items: center;
    }

    .icon-percorso {
        &:before {
            content: var(--icon);
        }
    }

    .range {
        display: inline;
    }

    .dettaglio-fase {
        width: 100%;
        font-weight: bold;
    }
    .serie-container {
        margin-bottom: 10px;
    }
    .serie {
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        margin-bottom: 5px;

    }
    .ripetuta {
        font-weight: bold;
    }

    
    &.has-ripetute {
        --space: 5px;
        padding-top: 0;
        .serie-container {
            padding-left: var(--space);
        }
    }
    // Pillola come in frontend-v3 (MspAndatureDettaglio.vue); il mobile non carica
    // tema-brand.css, quindi i token hanno gli stessi valori come fallback.
    .ripetuta-dettaglio {
        display: block;
        width: fit-content;
        margin-bottom: var(--space);
        padding: 4px 16px;
        border-radius: 9999px;
        background: var(--col-sel-bg, #e4f4d7);
        color: var(--col-sel-ink, #326b23);
        font-size: 0.875rem;
        font-weight: bold;
    }

    &.mobile {
        flex-direction: row;
        &.has-ripetute {
            flex-direction: column;
        }
        .serie {
            display: flex;
            gap: var(--ui-space);
        }
        .andatura {
            display: block;
            .andatura-value {
                display: flex;
                gap: 5px;
                // baseline: il padding della pillola rpm non sposta il testo rispetto al resto della riga
                align-items: baseline;
                margin-bottom: 5px;
                flex-wrap: wrap;
            }

        }
        .andature-container {
            display: block;
        }

        .prefix,
        .suffix,
        .plus {
            display: none !important;
        }

        white-space: nowrap;
    }


}

</style>
